export default __webpack_public_path__ + "static/healthtech-da8aca04b57ee87d4976dde8cb059c57.jpg";